module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class=\'detail\'>\n  ';
 if (item.get("viewable_permission")) { ;
__p += '\n    ';
 if (item.get('show_popup')) { ;
__p += '<a href=\'#\' class=\'change-fee-link\'>';
 } ;
__p += '\n\n    ';
 if (item.has('fee_method') || (item.has('per_order') && item.get('per_order').length > 0)) {
    ;
__p += '\n      ';
 const payments = [] ;
__p += '\n      ';
 if (item.has('per_order') && item.get('per_order').length > 0) { ;
__p += '\n        ';
 item.get('per_order').forEach(function(billing_item) {
          payments.push(item.formatCurrency(billing_item.fee_amount) + ' paid by ' + billing_item.fee_method.toLowerCase());
        }) ;
__p += '\n      ';
 } ;
__p += '\n      ';
 if (item.has('fee_method')) { ;
__p += '\n        ';
 payments.push(`${item.get('fee_amount') > 0 ? item.formatCurrency(item.get('fee_amount')) : ''} paid by ${item.get('fee_method').toLowerCase()}`) ;
__p += '\n      ';
 } ;
__p += '\n      ' +
((__t = ( payments.join(', ') )) == null ? '' : __t) +
'\n    ';
 } else { ;
__p += '\n        ';
 if (item.get('show_popup')) { ;
__p += 'Edit';
 } ;
__p += '\n    ';
 } ;
__p += '\n\n    ';
 if (item.get('show_popup')) { ;
__p += '<i class=\'fa fa-pencil\'></i></a>';
 } ;
__p += '\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
}